import React from 'react';
import { Box, Typography } from '@mui/material';

const MessageReplyPreview = ({ message, scrollToMessage }) => {
  if (!message.replyTo) {
    return null;
  }

  const handleClick = (event) => {
    event.stopPropagation();

    if (scrollToMessage && message.replyTo.messageUuid) {
      scrollToMessage(message.replyTo.messageUuid);
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={(theme) => {
        // Enviada: balão primarySoft, tons derivados do contrastText dele; recebida: do primary.
        const palette = (theme.vars || theme).palette;
        return {
          borderLeft: '3px solid',
          borderColor: message.isSent
            ? theme.alpha(palette.primarySoft.contrastText, 0.5)
            : palette.primary.main,
          pl: 1.5,
          mb: 1,
          py: 0.5,
          bgcolor: message.isSent ? palette.action.selected : theme.alpha(palette.primary.main, 0.08),
          borderRadius: 1,
          cursor: scrollToMessage && message.replyTo.messageUuid ? 'pointer' : 'default',
          '&:hover': scrollToMessage && message.replyTo.messageUuid ? {
            bgcolor: message.isSent ? palette.action.focus : theme.alpha(palette.primary.main, 0.12),
          } : undefined,
        };
      }}
    >
      <Typography
        variant="caption"
        sx={(theme) => ({
          display: 'block',
          mb: 0.3,
          color: message.isSent
            ? theme.alpha((theme.vars || theme).palette.primarySoft.contrastText, 0.9)
            : (theme.vars || theme).palette.primary.main,
        })}
      >
        {message.replyTo.name || 'Mensagem respondida'}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          opacity: 0.8,
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {message.replyTo.text || message.replyTo.waMessageId || message.replyTo.messageUuid}
      </Typography>
    </Box>
  );
};

export default MessageReplyPreview;
